import { postUploadFile } from "api/upload";
import axios from "axios";
export const PATH_S3_URL = "https://energyx.file.s3.ap-northeast-2.amazonaws.com";

export const useFile = () => {
  const upload = <returnValueType>({
    file,
    category,
    identity,
  }: {
    file: Blob;
    category: string;
    identity?: string;
  }) => {
    const formData = new FormData();
    formData.append("upload", file);
    formData.append("category", category);
    identity && formData.append("identity", identity);

    return postUploadFile<returnValueType>({ formData });
  };

  const download = async ({ path, originName }: { path: string; originName: string }) => {
    if (!path || !originName) return;
    const a = window.document.createElement("a");
    window.document.body.appendChild(a);
    a.style.cssText = "dispaly:none";

    if (path.includes("docs.esignon.net")) {
      await esignOnDownload({ a, path, originName });
    } else {
      await S3Download({ a, path, originName });
    }
  };

  const S3Download = async ({
    a,
    path,
    originName,
  }: {
    a: HTMLAnchorElement;
    path: string;
    originName: string;
  }) => {
    try {
      const res = await axios({
        method: "get",
        url: path,
        responseType: "blob",
        headers: {
          Accept: "*/*",
          "Access-Control-Allow-Origin": `${PATH_S3_URL}:80`,
        },
        proxy: {
          host: PATH_S3_URL,
          port: 80,
        },
        withCredentials: false,
        transformRequest: (data1, headers) => {
          headers && delete headers.Authorization;
        },
      });
      const { data } = res;
      const blob = new Blob([data], { type: res.headers["content-type"] });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `${originName}`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      throw new Error(error as any);
    }
  };

  // esignon문서 다운로드
  const esignOnDownload = async ({
    a,
    path,
    originName,
  }: {
    a: HTMLAnchorElement;
    path: string;
    originName: string;
  }) => {
    try {
      a.href = path;
      a.download = `${originName}`;
      a.click();
    } catch (error) {
      throw new Error(error as any);
    }
  };

  return { upload, download };
};
